export const types = {
    ERROR_REQUESTING_ADDRESS: 'ERROR_REQUESTING_ADDRESS',
    RECEIVED_ADDRESS: 'RECEIVED_ADDRESS',
    REQUEST_ADDRESS: 'REQUEST_ADDRESS'
};

export const errorRequestingAddress = (error) => ({
    payload: {
        error
    },
    type: types.ERROR_REQUESTING_ADDRESS
});

export const receivedAddress = (validation_response) => ({
    payload: {
        validation_response
    },
    type: types.RECEIVED_ADDRESS
});

export const requestAddress = (address) => ({
    payload: {
        address
    },
    type: types.REQUEST_ADDRESS
});


// WEBPACK FOOTER //
// ./src/actions/smartystreets.js